interface StorageDriver {
  get(key: string): string | null;
  set(key: string, value: string): void;
  remove(key: string): void;
}

export default class CustomStorage {
  constructor(private readonly storage: StorageDriver) {}

  open = async () => this.storage;

  create = async <T extends { id: string }>(user: T) => {
    this.storage.set(user.id, JSON.stringify(user));

    return user;
  };

  getById = async <T = unknown>(id: string): Promise<T | null> => {
    const item = this.storage.get(id);

    if (!item) return null;

    return JSON.parse(item) as T;
  };

  getAll = async () => {
    return [];
  };

  update = async <T extends Record<string, unknown>>(
    id: string,
    updates: Partial<T>,
  ) => {
    const item = await this.getById<T>(id);

    if (!item) throw new Error("User not found");

    const updatedItem = {
      ...item,
      ...updates,
    };

    this.storage.set(id, JSON.stringify(updatedItem));

    return updatedItem;
  };

  delete = async (id: string) => {
    this.storage.remove(id);

    return true;
  };

  reset = async () => {
    this.storage.remove("local-user");

    return true;
  };
}
